import { inject } from '../../../../../../common/container/inject';
import { IProjectModel } from '../../../../../../service/project/IProjectModel';
import { IRootAdminService, RootAdminServiceToken } from '../../../../../../service/RootAdminService';
import { IAnalyticsProjectDomain } from './IAnalyticsProjectDomain';

export class AnalyticsProjectDomain implements IAnalyticsProjectDomain {
  constructor(
    private rootAdminService = inject<IRootAdminService>(RootAdminServiceToken),
  ) {}

  getProjectById = (projectId: string): Promise<IProjectModel> => this.rootAdminService.project.entity.getById(projectId);
}
